import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, switchMap } from "rxjs";

import { Action } from "@app/models";

import { ActionListItemService } from "../../services/action-list-item.service";

@Component({
  selector: "action-sales-meeting-updated",
  template: `
    <div class="display-flex-start">
      <span [innerHTML]="text | async" class=""></span>&nbsp;
      <contact-summary [contactId]="item.contactId"></contact-summary>
    </div>
    <div>
      <small *ngIf="item.street?.length > 0" class="text-muted">
        <strong>{{ "address" | translate }}: </strong>
        <span
          class="text-link"
          (click)="itemService.navigateToObject(item.eaOid)"
          >{{ item.street }}
        </span>
      </small>
    </div>
  `,
  styleUrls: ["./common.scss"],
})
export class ActionSalesMeetingUpdatedComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() item: Action;

  text: Observable<string>;
  listenerName: Function;

  className = "action-sales-meeting-updated-name";

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private translateService: TranslateService,
    public itemService: ActionListItemService
  ) {}

  ngOnInit() {
    this.text = this.itemService.getYouTranslation(this.item).pipe(
      switchMap((youString: string) =>
        this.translateService.get("action_sales_meeting_updated_text", {
          you: youString,
          name: `<span class="${this.className} text-link">${this.item.firstName} ${this.item.familyName}</span>`,
        })
      )
    );
  }

  ngAfterViewInit() {
    this.listenerName = this.itemService.createContactLinkListener(
      this.elementRef,
      this.renderer,
      this.className,
      this.item.contactId
    );
  }

  ngOnDestroy() {
    const listeners = [this.listenerName];
    listeners.forEach((listener: Function) => {
      if (listener) {
        listener();
      }
    });
  }
}
